import React from 'react';
import * as Ant from 'antd';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import * as JStorage from '../../JStorage';
import ResetEmailButton from 'rev.sdk.js/Components/ResetEmailButton';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as Theme from '../../Theme';
import qs from 'query-string';
import GenericForm from 'rev.sdk.js/Generic/Form';
import {formSpec, lawServiceSpec} from './form-spec';
import RjsfAddressField from '../../Components/RjsfAddressField';
import TdaUserProfileRevisionButton from '../../Components/TdaUserProfileRevisionButton';
import RegisterProgress from '../../Components/RegisterProgress';
import Breadcrumb from '../../Components/Breadcrumb';
import _ from 'lodash';
import EditProfileForm from '../../Components/EditProfileForm';
import useDocuments from '../../Hooks/useDocuments';

function ProfilePage(props) {
  const {} = qs.parse(props.location.search);
  const [user, setUser] = useOutlet('user');

  const {total: revisionTotal, refresh: getRevisions} = useDocuments({
    defaultFilters: {
      owner: user.sub || '-',
      status: {$nin: ['approved', 'rejected']},
      limit: 1,
    },
    collection: 'revision',
  });

  React.useEffect(() => {
    getRevisions();
  }, [getRevisions]);

  if (!user) {
    return null;
  }

  return (
    <Wrapper id="tda-user-profile">
      {user.data?.status === 'reviewing' && <RegisterProgress current={3} />}

      <div className="tda-header">
        <h2>基本資料</h2>
        <Breadcrumb />
      </div>

      {revisionTotal > 0 && (
        <Ant.Alert
          showIcon
          type="info"
          message={`尚有${revisionTotal}筆更新未審核`}
          description="待公會人員審核完畢後，將會更新個人資料，請耐心等候，詳情可檢視資料異動紀錄"
          style={{marginBottom: 20}}
        />
      )}

      <EditProfileForm
        onSuccess={(next) => {
          // setUser({
          //   ...user,
          //   data: {
          //     ...user.data,
          //     ...next,
          //   },
          // });
          getRevisions();
          Ant.message.success(
            '待公會審核完成後，更新於基本資料，您可於本頁最下方，查看所有修改的歷程',
          );
        }}
      />

      {/* {finalFormSpec && (
        <GenericForm
          {...finalFormSpec}
          rjsfProps={rjsfProps}
          instance={user.data}
          renderCustomSubmitButton={({values: formData}) => {
            return (
              <Ant.Button
                type="primary"
                style={{marginTop: 20}}
                onClick={async () => {
                  AppActions.setLoading(true);
                  try {
                    const resp = await AppActions.tdaUpdateUserProfile(
                      formData,
                    );
                    setUser({
                      ...user,
                      data: {
                        ...user.data,
                        ...resp,
                      },
                    });
                    
                  } catch (ex) {
                    Ant.message.error(`API error ${ex}`);
                  }
                  AppActions.setLoading(false);
                }}>
                更新個人資料
              </Ant.Button>
            );
          }}
        />
      )} */}

      <h2>其他功能</h2>
      <div style={{display: 'flex', gap: 12}}>
        <TdaUserProfileRevisionButton owner={user?.sub} />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div``;

export default withPageEntry(ProfilePage);
